import moment from "moment";
import "moment-timezone";
export const formatDate = (date) => {
  if (!date) {
    return moment().tz("Europe/Paris").locale("fr").format("dddd DD MMM");
  }
  return moment(date).tz("Europe/Paris").locale("fr").format("dddd DD MMM");
};

export const formatLongDate = (date) => {
  if (!date) {
    return moment().locale("fr").format("dddd DD MMMM");
  }
  return moment(date).locale("fr").format("dddd DD MMMM");
};

export const formatDateWithSpecifiedFormat = (date, desired_format, initial_format) => {
  if (!date) {
    return moment().locale("fr").format(desired_format);
  }
  return moment(date, initial_format).locale("fr").format(desired_format);
};

export const formatTime = (beginning, end) => {
  if (!beginning || !end) {
    return "format incorrect";
  }
  return `${moment(beginning).format("H:mm")} et ${moment(end).format("H:mm")}`;
};

export const isInPast = (date) => {
  return moment(date).isBefore(moment());
};
